<template>
  <div class="saved-assessments" v-show="isActive">
    <div v-if="savedAssessmentCount == 0">
      <div class="no-item">
        <div class="text-center">
        <img class="pb-3" src="~@/assets/images/no-assessment.svg" alt="No assessments" />
        <p class="no-assessment">There are no projects</p>
      </div>
      </div>
    </div>
    <div v-else>
      <div class="count">
        {{ savedAssessmentCount }} saved project{{
          savedAssessmentCount === 1 ? "" : "s"
        }}
      </div>
      <hr class="solid" />
      <div id="accordion">
        <div
          
          v-for="(assessment, i) in satContent.Tools"
          :key="assessment.Id"
          
        >
          <template v-if="assessment.SavedAssessmentDateCreated">
            <div class="card mb-3">
            <!-- Header -->
            <button
              class="card-header collapsed"
              :aria-controls="`collapse-${i}`"
              data-toggle="collapse"
              data-parent="#accordion"
              :href="`#collapse-${i}`"
              aria-expanded="false"
            >
              <div class="p-0 mb-0 w-100 btn">
                <div class="item-group-1">
                  <div class="assessment-name">{{ assessment.Name }}</div>
                   <span class="date d-md-none"
                    >Last saved {{ dateUpdated(assessment) }}</span
                  >
                </div>
                <div class="item-group-2">
                  <span class="date d-none d-md-block"
                    >Last saved {{ dateUpdated(assessment) }}</span
                  >
                </div>
              </div>
            </button>
            <!-- Header End -->
            <!-- Body -->
            <div
              :id="`collapse-${i}`"
              class="collapse"
            >
              <div class="card-body">
                <div
                  v-for="standard in assessment.Standards"
                  :key="standard.Id"
                >
                  <OverviewSavedAssessmentsStandard
                    :standard="standard"
                    :satId="assessment.Id"
                  />
                </div>
 <!-- Button -->
               <div
                class="form-row card-buttons flex-column-reverse flex-md-row"
              >
                <div class="col-12 col-md-6">
                  <a
                    class="view"
                    v-if="assessment.FeedbackLinkUrl"
                    :href="assessment.FeedbackLinkUrl"
                    :target="assessment.FeedbackLinkTarget"
                    >{{ assessment.FeedbackLinkText }}</a
                  >
                </div>
                <div class="col-12 col-md-6 summary-button">
                  <button 
                    @click="routeToActionPlan(assessment.Id)"
                      @keydown="routeToActionPlan(assessment.Id)"
                    class="cta-white-280"
                  >
                    View detailed summary<span class="angle-right-white"></span>
                  </button>
                </div>
              </div> 
              <!-- Button End -->

              </div>
              <!-- <div class="col-6 col-md-2 date">ccc</div>
            <div class="col-6 col-md-2">
              <a class="view" @click="routeToReview(assessment.Id, standard.Id)"
                >Review <span class="angle-right-green"></span>
              </a>
            </div> -->
              <!-- </div> -->
             
            </div>
            <!-- Body End -->
            </div>
          </template>
        </div>
      </div>
      <!-- Accordion End -->
    </div>
    <div class="space"></div>
  </div>
</template>

<script>
import { privateRouter } from "../router";
import OverviewSavedAssessmentsStandard from "@/components/overview-saved-assessments-standard";
import moment from "moment";

export default {
  name: "OverviewSavedAssessments",
  components: {
    OverviewSavedAssessmentsStandard
  },
  data() {
    return {
      isActive: true
      //assessmentCount: this.satContent.Tools.length
    };
  },
  created() {},
  props: {
    satContent: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    routeToStandard(satId, standardId) {
      privateRouter.push({
        name: "AssessmentStandard",
        query: {
          satId: satId,
          standardId: standardId
        }
      });
    },
    routeToActionPlan(satId) {
      privateRouter.push({
        name: "ActionPlan",
        query: {
          satId: satId
        }
      });
    },
    dateUpdated(currentAssessment) {
      let savedResponses = [];

      // get saved responses for this assessment
      currentAssessment.Standards.forEach(standard => {
        standard.Sections.forEach(section => {
          section.Questions.forEach(question => {
            if(question.SAT_SavedResponses.Id) { // responses sometimes hang around as empty objects after being deleted
              savedResponses.push(question.SAT_SavedResponses); 
            }
          })
        })
      })

      if(savedResponses) {
        savedResponses.sort(function(savedResponses,b){ // sort responses by DateUpdated descending
          return new Date(b.DateUpdated) - new Date(savedResponses.DateUpdated)
        })
        return moment(savedResponses[0].DateUpdated).format("LL") // get last saved response
      } else {
        return "Assessment not saved";
      }
    }
  },
  computed: {
    savedAssessmentCount() {
      let savedAssessments = 0;
      this.satContent.Tools.forEach(tool => {
        if (tool.SavedAssessmentDateCreated) {
          // assessments that have never been saved will have null SavedAssessmentDateCreated
          savedAssessments++;
        }
      });
      return savedAssessments;
    }
  }
};
</script>

<style lang="sass" scoped></style>
